import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
            I love coding because with just a few lines of code I can turn my ideas into reality, which potentially can impact the world and shape the future.
              <br />
              <br />I am fluent in classics like
              <i>
                <b className="purple"> Java, C++, Python, SQL, NOSQL. </b>
              </i>
              <br />
              <br />
              I learned the basics of programming in Java during my schooling and I gained an interest in coding. I have done a project related to a Vehicle-pedestrian detection system, a Face mask detection system using a haar cascade algorithm, AWS Projects and worked on implementation of the lookup algorithm in Pyramid tree Peer to Peer Network architecture using C++.
              
              <br />
              <br />
              During my master's, I gained a lot of interest in how data is processed and how to handle terabytes of data and I am fond of learning about data-related technologies. In this journey, I gained knowledge of differences between SQL and NOSQL concepts in databases. I also gained knowledge of tools like AWS, Apache Hadoop, Apache Spark, ETL tools, and Data Warehousing Tools.
              
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/sathwick9"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/sathwick-paladugu-1311a852/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/wickey007/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
